(function () {
  'use strict';

  /**
   * @typedef {import('./types').PopupScope} PopupScope
   */

  angular
    .module('settings.popup')
    .controller('settingsPopupCtrl', settingsPopupCtrl);

  settingsPopupCtrl.$inject = ['$mdDialog', '$scope', '$translate'];

  /**
   * @param {angular.material.IDialogService} $mdDialog
   * @param {PopupScope} $scope
   */
  function settingsPopupCtrl($mdDialog, $scope, $translate) {
    var vm = this;
    vm.loaded = true;
    vm.model = $scope.model;
    vm.data = $scope.data;

    vm.onSubmit = function () {
      $scope.object = vm.model;
      $scope.onSubmit({ object: $scope.object });
      vm.closeDialog();
    };

    vm.closeDialog = function () {
      $mdDialog.hide();
      $scope.onBack();
    };

    vm.addOptionInEdit = function (index) {
      if (typeof index != 'undefined') {
        vm.model.data.splice(index + 1, 0, '');
      } else {
        vm.model.data.push('');
      }
    };

    vm.addGroupInEdit = function () {
      vm.model.data.push(
        '-- ' +
          $translate.instant(
            'settings.page.customizations.custom.table.group',
          ) +
          ' --',
      );
    };
  }
})();
